export const NotFound = () => {
    return <div className="centered">
    <h1>404</h1>
    <h2>Page not found</h2>
    <p>Sorry, the requested page could not be found.</p>
</div>
}